import { routes } from "../apiroutes";
import HttpService from "../httpServices";
import { ErrorHandler } from "../errorHandler";
import useFetchItem from "../useFetchItem";
import useMutateItem from "../useMutateItem";
import { showErrorAlert, showSuccessAlert } from "../../utils/alert";

const httpService = new HttpService();

// Get user profile
export const useGetUserProfile = ({ enabled = true } = {}) => {
  const { isFetched, isLoading, error, data, refetch, isFetching } = useFetchItem({
    queryKey: ["userProfile"],
    queryFn: () => httpService.getData(routes.getUserProfile()),
    enabled,
    retry: 2
  });

  return {
    profileIsFetching: isFetching,
    profileIsFetched: isFetched,
    profileIsLoading: isLoading,
    profileError: ErrorHandler(error),
    profileData: data?.data || {},
    refetchProfile: refetch
  };
};

// Update user profile
export const useUpdateUserProfile = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) => httpService.putData(payload, routes.updateUserProfile()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Profile updated successfully");
      handleSuccess?.(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    updateProfileData: data,
    updateProfileError: ErrorHandler(error),
    updateProfileIsLoading: isPending,
    updateProfilePayload: (requestPayload) => mutate(requestPayload),
  };
};

// Change password - using existing route
export const useChangePassword = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) => httpService.postData(payload, routes.changePassword()),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Password changed successfully");
      handleSuccess?.(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    changePasswordData: data,
    changePasswordError: ErrorHandler(error),
    changePasswordIsLoading: isPending,
    changePasswordPayload: (requestPayload) => mutate(requestPayload),
  };
};

// Delete account
export const useDeleteAccount = (handleSuccess) => {
  const { data, error, isPending, mutate } = useMutateItem({
    mutationFn: (payload) => httpService.deleteData(routes.deleteAccount(), payload),
    onSuccess: (res) => {
      const resData = res?.data || {};
      showSuccessAlert(resData?.message || "Account deleted successfully");
      handleSuccess?.(resData);
    },
    onError: (err) => {
      const error = ErrorHandler(err);
      showErrorAlert(error);
    },
  });

  return {
    deleteAccountData: data,
    deleteAccountError: ErrorHandler(error),
    deleteAccountIsLoading: isPending,
    deleteAccountPayload: (requestPayload) => mutate(requestPayload),
  };
}; 